/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `ACCEPTED` - Accepted * `CANCELLED` - Cancelled * `COMPLETE` - Complete * `DECLINED` - Declined * `EXPIRED` - Expired * `IN_PROGRESS` - In Progress * `OPEN` - Open
 * @export
 * @enum {string}
 */
export enum BookingRequestStatusEnum {
    Accepted = 'ACCEPTED',
    Cancelled = 'CANCELLED',
    Complete = 'COMPLETE',
    Declined = 'DECLINED',
    Expired = 'EXPIRED',
    InProgress = 'IN_PROGRESS',
    Open = 'OPEN'
}



